module.exports = "https://coursera_assets.s3.amazonaws.com/images/79564e0d573402c299689fb834181c9c.jpg";